
export class Login {
    first_name:string;
    last_name:string;
    avatar?:string;
    title?:string;
}